module.exports = __webpack_public_path__ + "static/media/VGS_Phone_02.12359274.png";